import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';

const renderStoreLink = ({ storeData }) => {
  const slug =
    storeData.slug?.replace(/^\/+|\/+$/g, '')?.replace(/^showrooms\//, '') ||
    '';
  const showroomUrl = slug ? `/showrooms/${slug}/` : '/showrooms/';
  return (
    <div key={storeData.id} className="text-sm ml-2">
      <Link
        to={showroomUrl}
        className="text-brand underline hover:no-underline !font-bold"
      >
        {storeData.city}, {storeData.state}
      </Link>
    </div>
  );
};

const ShowroomLocatorResults = ({
  loading,
  error,
  stores,
  onClose,
  isMobile,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (loading) {
    return <div className="text-sm text-gray mt-2">Searching...</div>;
  }

  if (error) {
    return (
      <div className="mt-2">
        <div className="text-sm text-red mb-2">
          Error searching for showroom. Please try again.
        </div>
      </div>
    );
  }

  const validStores = stores.filter(store => store.storeData);
  const hasMultipleStores = validStores.length > 1;
  const additionalStoresCount = validStores.length - 1;
  const storesToShow = isExpanded ? validStores : validStores.slice(0, 1);

  if (validStores.length > 0) {
    return (
      <div
        className={`mt-2 ${
          isMobile ? '' : 'pt-2 [border-top:1px_solid_#f1f1f1]'
        }`}
      >
        <div className="flex justify-between items-start">
          <div className="text-sm text-gray mb-1">Showroom results:</div>
          {!isMobile && onClose && (
            <button
              type="button"
              onClick={onClose}
              className="text-gray pt-2 pr-1"
              aria-label="Close results"
            >
              <IconClose width={10} height={10} />
            </button>
          )}
        </div>
        {storesToShow.map(renderStoreLink)}
        {hasMultipleStores && !isExpanded && (
          <button
            type="button"
            onClick={() => setIsExpanded(true)}
            className="text-sm text-brand underline hover:no-underline mt-1 ml-2 !font-bold"
          >
            + {additionalStoresCount} more
          </button>
        )}
      </div>
    );
  }

  return (
    <div
      className={`mt-2 ${isMobile ? '' : 'pt-2 border-t border-t-gray-light5'}`}
    >
      <div className="flex justify-between items-start">
        <div className="text-sm text-gray mb-1">Showroom results:</div>
        {!isMobile && onClose && (
          <button
            type="button"
            onClick={onClose}
            className="text-gray pt-2 pr-1"
            aria-label="Close results"
          >
            <IconClose width={10} height={10} />
          </button>
        )}
      </div>
      <div className="text-sm text-red mb-1 pl-2">
        No showrooms within range
      </div>
      <div className="text-sm text-gray pl-2">
        Try our{' '}
        <Link to="/showrooms/virtual/" className="text-brand underline">
          Virtual Showroom
        </Link>
      </div>
    </div>
  );
};

ShowroomLocatorResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  stores: PropTypes.array,
  onClose: PropTypes.func,
  isMobile: PropTypes.bool,
};

ShowroomLocatorResults.defaultProps = {
  stores: [],
  onClose: null,
  isMobile: false,
};

export default ShowroomLocatorResults;
